import getConfig from 'next/config'

import {
  PatchBidProps,
  patchBid as patchBidLib,
  usePatchBid as usePatchBidLib,
} from '@nx/api'

const { publicRuntimeConfig } = getConfig()

export const patchBid = (props: Omit<PatchBidProps, 'baseURL'>) =>
  patchBidLib({ baseURL: publicRuntimeConfig.WEB_API_URL, ...props })

export const usePatchBid = () =>
  usePatchBidLib({ baseURL: publicRuntimeConfig.WEB_API_URL })
